import React from 'react'

const Modal = ({comment, emailId, occupation, phone, phoneDisplay, title}) => {
  return (
    <div className="modal right fade" id="Modal-Sophie" tabIndex="1" role="dialog" aria-labelledby="Modal-Sophie" aria-hidden="true">
        <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
                <div className="modal-body p-0">
                    <button type="button" className="close top-close" data-dismiss="modal" aria-label="Close">
                        <img src="images/modal-close-white.svg" className="img-fluid" alt="" />
                    </button>
                    <img src="images/mick-drower-modal.jpg" className="img-fluid center-block" alt="" />
                    <div className="team-modal" />
                        <h1>{title}</h1>
                        <h4>{occupation}</h4>
                        <p>{comment[0]}</p>
                        <p>{comment[1]}</p>
                        <ul className="clearfix team-modal-link">
                            <li><a href={`tel: ${phone}`}>{phoneDisplay}</a></li>
                            <li><a href={`emailto:${emailId}`}>{emailId}</a></li>
                        </ul>
                        <button type="button" className="btn btn-grey-border btn-block" data-dismiss="modal" style={{maxWidth: "200px"}}>Close</button>
                    </div>
                </div>
            </div>
        </div>
  
  )
}

export default Modal